import React, { useState } from 'react';
import './Products.css';

const Products = () => {
  const [searchQuery, setSearchQuery] = useState('');
  
  const products = [
    {
      name: 'Anti Roll Bars',
      description: 'High-strength stabilizer bars that reduce body roll during cornering, enhancing vehicle stability and handling.',
      image: '/Photos/Products/Anti Roll Bars Volvo FM460.png'
    },
    {
      name: 'Brake Adjusters',
      description: 'Automatic slack adjusters for optimal brake performance and maintenance. Ensures consistent braking efficiency.',
      image: '/Photos/Products/Break Adjusters Volvo FM460.png'
    },
    {
      name: 'Brake Drums',
      description: 'Heavy-duty brake drums designed for superior heat dissipation and long-lasting performance.',
      image: '/Photos/Products/Break Drums Volvo FM460.png'
    },
    {
      name: 'Brake Linings',
      description: 'High-friction brake linings providing reliable stopping power and extended service life.',
      image: '/Photos/Products/Break linings Volvo FM460.png'
    },
    {
      name: 'Brake Pinions',
      description: 'Precision-manufactured brake pinions ensuring smooth brake operation and optimal force distribution.',
      image: '/Photos/Products/Break pinions Volvo FM460.png'
    },
    {
      name: 'Cabin Mountings',
      description: 'Robust cabin mounting systems that reduce vibration and noise, enhancing driver comfort.',
      image: '/Photos/Products/Cabin Mountings Volvo FM460.png'
    },
    {
      name: 'Clutch Plates',
      description: 'Heavy-duty clutch plates for smooth power transmission and extended durability.',
      image: '/Photos/Products/Clutch Plates Volvo FM460.png'
    },
    {
      name: 'Fly Wheels',
      description: 'Precision-balanced flywheels ensuring smooth engine operation and reduced vibration.',
      image: '/Photos/Products/Fly Wheels Volvo FM460.png'
    },
    {
      name: 'Hub Bolts',
      description: 'High-tensile strength hub bolts providing secure wheel mounting and reliable performance.',
      image: '/Photos/Products/Hub Bolts Volvo FM460.png'
    },
    {
      name: 'Leaf Springs',
      description: 'Heavy-duty parabolic leaf springs delivering excellent load distribution and ride comfort.',
      image: '/Photos/Products/Leaf springs VOLVO FM460.png'
    },
    {
      name: 'Pressure Plates',
      description: 'High-performance pressure plates ensuring consistent clutch engagement and smooth power delivery.',
      image: '/Photos/Products/Pressure Plates Volvo FM460.png'
    },
    {
      name: 'Release Bearings',
      description: 'Premium quality release bearings for smooth clutch operation and extended service life.',
      image: '/Photos/Products/Release Bearings Volvo FM460.png'
    },
    {
      name: 'U Bolts',
      description: 'Heavy-duty U-bolts for secure spring mounting and reliable suspension assembly.',
      image: '/Photos/Products/U Bolts Volvo FM460.png'
    }
  ];

  // Filter products based on search query
  const filteredProducts = products.filter(product =>
    product.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="products-page">
      <div className="products-hero">
        <h1 className="products-title">Our Products</h1>
        <p className="products-subtitle">
          High-quality aftermarket spare parts for heavy commercial vehicles
        </p>
      </div>

      <div className="products-container">
        <div className="products-intro">
          <p>
            GSPS Trading Corporation offers a comprehensive range of aftermarket spare parts 
            for VOLVO, BHARAT BENZ, EICHER, and MAN heavy commercial vehicles.These are only some of our products. We have 250+ products for each brand. You can contact us for enquiry.
          </p>
        </div>

        {/* Search Bar */}
        <div className="search-container">
          <div className="search-bar">
            <svg 
              className="search-icon" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" 
              />
            </svg>
            <input
              type="text"
              placeholder="Search products..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
            />
            {searchQuery && (
              <button 
                className="clear-button"
                onClick={() => setSearchQuery('')}
                aria-label="Clear search"
              >
                <svg 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M6 18L18 6M6 6l12 12" 
                  />
                </svg>
              </button>
            )}
          </div>
          {searchQuery && (
            <p className="search-results-text">
              Found {filteredProducts.length} product{filteredProducts.length !== 1 ? 's' : ''}
            </p>
          )}
        </div>

        <div className="products-grid">
          {filteredProducts.length > 0 ? (
            filteredProducts.map((product, index) => (
            <div key={index} className="product-card">
              <div className="product-image-container">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="product-image"
                />
              </div>
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-description">{product.description}</p>
              </div>
            </div>
          ))
          ) : (
            <div className="no-results">
              <svg 
                className="no-results-icon" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
                />
              </svg>
              <h3>No products found</h3>
              <p>Try adjusting your search terms</p>
            </div>
          )}
        </div>

        <div className="products-cta">
          <p className="cta-text">Need a specific part? Contact us for availability and pricing.</p>
          <a href="#contact" className="cta-button">Contact Us</a>
        </div>
      </div>
    </div>
  );
};

export default Products;

